globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalRelatedComments = (function(superClass)
{
    utils.extend(ModalRelatedComments, superClass);

    function ModalRelatedComments($html) {
      return ModalRelatedComments.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalRelatedComments.prototype, {

    });

    return ModalRelatedComments;
})(backoffice.ModalMain);
